import { combineReducers } from "redux";
import torrePesados from "./slices/torrePesados.slice";

const reducer = combineReducers({
  torrePesados,
});

export default reducer;
